// Global
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
//import { useTheme } from 'lib/context/ThemeContext';
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
// Components
import Component from 'src/helpers/Component/Component';
import Script from 'next/script';
import Head from 'next/head';
import { getEnum } from 'lib/utils/get-enum';
import { ThreekitVisualizerTheme } from './ThreekitVisualizer.theme';
import classNames from 'classnames';
import { useTheme } from 'lib/context/ThemeContext';
import { useEffect, useRef, useState } from 'react';
import { useIsVisible } from 'lib/utils/use-is-visible';

export type ThreekitVisualizerProps =
  Feature.EnterpriseWeb.RenewalByAndersen.Components.Product.ThreekitVisualizer;
const ThreekitVisualizer = (props: ThreekitVisualizerProps) => {
  const { themeData } = useTheme(ThreekitVisualizerTheme);
  const visualizerRef = useRef<HTMLDivElement>(null);
  const isVisible = useIsVisible(visualizerRef);
  const [cacheBuster, setCacheBuster] = useState<number>(0);

  useEffect(() => {
    setCacheBuster(Date.now());
  }, []);

  if (!props.fields) {
    return <></>;
  }
  const productId = getEnum<string>(props.fields.productId);
  return (
    <>
      <Head>
        <link href={props.fields.cssHref?.value} rel="stylesheet" />
      </Head>
      {isVisible && (
        <Script src={props.fields.scriptSrc?.value + `?d=${cacheBuster}`} strategy="lazyOnload" />
      )}
      <Component variant="lg" dataComponent="product/threekitvisualizer" {...props}>
        {productId && <input type="hidden" id="productId" value={productId} />}
        <div
          ref={visualizerRef}
          className={classNames(themeData.classes.body, 'tk-treble-app')}
          id="tk-treble-root"
        ></div>
      </Component>
    </>
  );
};

export default withDatasourceCheck()<ThreekitVisualizerProps>(ThreekitVisualizer);
